<template>
  <div class="gp-main-body-content">
    <div id="assignment">
      <div class="col-lg-12" v-if="totalPages >= 1 || statusList.loading">
        <div class="row head">
          <div class="col-lg-5 col-mlg-4">
            <div class="row">
              <GpInputSearch
                class="ml-auto"
                ref="GpRealInput"
                :clear="currentSearch ? true : false"
                :placeholder="
                  $t('page.assignment.filter', {
                    type: $tc(`page.${pType}`, 1)
                  })
                "
                @onChange="onChangeSearch"
                v-model="currentSearch"
              />
            </div>
          </div>
          <div class="col col-lg-7 col-mlg-8 px-0 mt-2 mt-lg-0">
            <button class="btn btn-primary ml-lg-auto" @click.stop="openAssignModel">{{ btnSetTemplateText }}</button>
          </div>
        </div>
      </div>

      <div class="content" v-if="totalPages >= 1 || statusList.loading">
        <template v-if="isLoading && !isFetchingPages">
          <GpListLoading :type="'assignment'" :quantity="8" />
        </template>

        <AssignmentList v-else>
          <template v-slot:AssignmentItem>
            <template v-if="currentPage == 1 && !currentSearch">
              <AssignmentItem v-if="sortedPages && sortedPages.length" :itemType="'default'" :pages="sortedPages" :type="type" :assign="defaultItem" />
            </template>
            <template v-if="filterAssigns && filterAssigns.length && sortedPages && sortedPages.length">
              <AssignmentItem v-for="(assign, index) in filterAssigns" :key="index" :assign="assign" :pages="sortedPages" :type="type" />
            </template>
            <Pagination :paginationParam.sync="pagination" :total.sync="totalPagesPagination" @page="toPage" v-if="totalPages > pagination.limit" />
          </template>
        </AssignmentList>

        <GSnackBar v-if="handleAction" :type="statusType" :message="statusMessage" />
      </div>

      <template v-if="totalPages < 1 && !statusList.loading">
        <div class="pt-6 mt-3">
          <GpEmptyPage :page="'assignment'" :assignmentType="assignmentType" :pageType="type">
            <template #button="{btnText}">
              <div class="d-flex align-items-center justify-content-center">
                <button class="btn btn-primary" @click.stop="doCase">{{ btnText }}</button>
              </div>
            </template>
          </GpEmptyPage>
        </div>
      </template>

      <!-- <GpEmptyPage :page="'assignment'" :assignmentType="assignmentType" :pageType="type"></GpEmptyPage> -->

      <AssignmentModal :pages="sortedPages" :type="type" v-if="openModal" @close="closeAssignModel" />
    </div>
  </div>
</template>

<script>
import { GpInputSearch } from "@/core/shared/GpForms";
import { GpListLoading } from "@/core/shared/GpList";
import Pagination from "@/core/shared/essenstials/Pagination";
import { AssignmentModal } from "../components";
import GpEmptyPage from "@/core/shared/GpEmptyPage";
import AssignmentList from "../components/Assignment/AssignmentList";

import AssignmentItem from "../components/Assignment/AssignmentItem";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "Assignment",
  components: {
    GpInputSearch,
    AssignmentModal,
    AssignmentList,
    AssignmentItem,
    GpEmptyPage,
    GpListLoading,
    Pagination
  },
  props: {
    type: String
  },
  data() {
    return {
      assigns: [],
      pages: [],
      openModal: false,
      runnerSearch: null,
      statusType: "loading",
      statusMessage: "Processing",
      currentPage: 1,
      currentSearch: "",
      defaultItem: {
        title: this.type == "productpages" ? this.$t("page.assignment.defaultProducts") : this.$t("page.assignment.defaultCollection")
      }
    };
  },
  computed: {
    ...mapState("page", {
      assigmentList: "assignments",
      pagesList: "pages"
    }),
    ...mapState("account", {
      shopInfo: "shopInfo",
      permissions: "permissions"
    }),
    ...mapGetters("page", {
      allCollectionPages: "allCollectionPages",
      allProductPages: "allProductPages",
      getAssignments: "getAssignments"
    }),
    sortedPages() {
      switch (this.type) {
        case "collectionpages":
          return this.allCollectionPages;
        case "productpages":
          return this.allProductPages;
      }
      return [];
    },
    isLoading() {
      return this.statusList.loading || this.statusPage.loading;
    },
    pagination() {
      return this.assigmentList[this.type].pagination;
    },
    totalPagesPagination() {
      return Math.ceil(this.assigmentList[this.type].list.length / this.pagination.limit);
    },
    totalPages() {
      return this.assigmentList[this.type].list.length;
    },
    filterAssigns() {
      if (this.currentSearch) {
        return this.getAssignments({
          type: this.type,
          search: this.currentSearch,
          page: this.currentPage
        });
      }
      return this.getAssignments({ type: this.type, page: this.currentPage });
    },
    status() {
      return this.pagesList[this.type].status;
    },
    statusPage() {
      return this.assigmentList[this.type].status;
    },
    statusList() {
      return this.assigmentList[this.type].statusList;
    },
    pType() {
      if (!this.type) return "pages";
      let type = this.type.split("pages")[0];
      return type;
    },
    title() {
      return this.$t("page.assignment.title", {
        type: this.$tc(`page.${this.pType}`, 1)
      });
    },
    btnSetTemplateText() {
      return this.$t("page.setTemplate", {
        type: this.$tc(`page.${this.pType}`, 1)
      });
    },
    currentAssignType() {
      return this.assigmentList[this.type];
    },
    currentPageType() {
      return this.pagesList[this.type];
    },
    isFetchingPages() {
      return this.currentPageType.fetched && this.currentAssignType.fetched;
    },
    handleAction() {
      return this.isFetchingPages && (this.status.error || this.status.success || this.status.loading || this.statusPage.error || this.statusPage.success || this.statusPage.loading);
    },
    assignmentType() {
      if (!this.sortedPages || this.sortedPages.length <= 1) {
        return "case2";
      }
      return "case3";
    },
    isEmptyPagesList() {
      return this.currentPageType.fetched && !(this.sortedPages && this.sortedPages.length);
    }
  },
  watch: {
    type(newVal, oldVal) {
      if (newVal != oldVal) {
        this.fetch();
      }
    },
    status: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(newVal) {
        if (newVal.loading) {
          this.statusType = "loading";
          this.statusMessage = this.$t("status.processing");
        }
        if (newVal.success) {
          this.statusType = "success";
          this.statusMessage = this.$t("status.success");
        }
        if (newVal.error) {
          this.statusType = "error";
          this.statusMessage = this.$t("status.error");
        }
      }
    },
    statusPage: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(newVal) {
        if (newVal.loading) {
          this.statusType = "loading";
          this.statusMessage = this.$t("status.processing");
        }
        if (newVal.success) {
          this.statusType = "success";
          this.statusMessage = this.$t("status.success");
        }
        if (newVal.error) {
          this.statusType = "error";
          this.statusMessage = this.$t("status.error");
        }
      }
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    ...mapActions("page", {
      fetchAssignments: "fetchAssignments",
      fetchPages: "fetchPages",
      updateAssignmentsPagination: "updateAssignmentsPagination"
    }),
    ...mapMutations("page", {
      UPDATE_ASSIGNMENTS_PAGINATION: "UPDATE_ASSIGNMENTS_PAGINATION"
    }),
    doCase() {
      if (this.assignmentType == "case3") {
        this.openAssignModel();
      } else {
        let routeName = null;
        switch (this.type) {
          case "collectionpages":
            routeName = "CollectionPagesTemplate";
            break;
          case "productpages":
            routeName = "ProductPagesTemplate";
            break;
        }
        this.$router.replace({ name: routeName });
      }
    },
    fetch() {
      this.fetchAssignments({
        type: this.type,
        shop: this.shopInfo.shopifyDomain,
        onSuccess: () => {
          this.fetchPages({ type: this.type });
        }
      });
    },
    toPage(page) {
      this.currentPage = page;
      this.UPDATE_ASSIGNMENTS_PAGINATION({
        type: this.type,
        pagination: {
          page,
          limit: this.pagination.limit
        }
      });
    },
    openAssignModel() {
      this.openModal = true;
    },
    closeAssignModel() {
      this.openModal = false;
    },
    onChangeSearch(params) {
      const { value } = params;

      this.currentSearch = value;

      this.runnerSearch && clearTimeout(this.runnerSearch);
      this.runnerSearch = setTimeout(() => {}, 400);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.permissions[vm.type]) {
        if (from.name != "Pricing") vm.$router.replace({ name: "Pricing" });
        else vm.$router.replace({ name: "Dashboard" });
      }
      return true;
    });
  }
};
</script>

<style lang="scss" scoped>
#assignment {
  .title {
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    margin-top: 35px;
  }
}
</style>
